import { ApiService }        from '../../app-lite/api/api.service';
import { CompanyMessagesModel } from '../../app-lite/companies/models/company.messages';

import AdminReportsHtml from './admin-reports.html';
import ReportsHtml      from './reports.html';

export function ReportsStates (
  $stateProvider : ng.ui.IStateProvider
) {
  $stateProvider
  .state({
    controller : 'baseReport',
    name       : 'app.reports',
    templateUrl: ReportsHtml,
    url        : '/reports',
    resolve    : {
      branchList       : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/system/branch_store_list'),
      company          : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/company'),
      companyMessages  : ( $rootScope : any ) : ng.IPromise<CompanyMessagesModel> => $rootScope.Company.getDefaultMessages(),
      internalOnlyTypes: ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/system/internal_only_types'),
      limitTypes       : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/system/sales_report_limit_types'),
      locations        : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/products/locations'),
      mechanicList     : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/reports/mechanic_list'),
      orderColumns     : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/reports/valid_order_columns', '*'),
      orderStatusTypes : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/system/purchase_order_status_types'),
      productTypes     : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/system/product_types'),
      searches         : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/reports/valid_range_columns', '*'),
      transactionTypes : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/reports/transaction_log_list')
    }
  })
  .state({
    controller  : 'AdminReportsCtrl',
    controllerAs: '$ctrl',
    name        : 'app.admin-reports',
    templateUrl : AdminReportsHtml,
    url         : '/admin_reports',
    resolve     : {
      accountingTypes: ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/system/accounting_types')
    }
  });
};